<template>
  <div id="wrapper" class="position-relative w-100 overflow-hidden">
    <main id="main" class="py-60">
      <div class="container">
        <div class="box-shadow pt-30 pb-40">
          <div v-if="serverResponse && accountActivated" class="row justify-content-center">
            <div class="col-10">
              <h2 class="text-center mb-35">
                Your account has been activated!
                <span class="text-light-blue d-block"></span>
              </h2>
            </div>
            <div class="text-center">
              <button class="btn btn-primary px-40" @click="loginRedirection">Continue to Login</button>
            </div>
          </div>

          <div v-if="serverResponse && !accountActivated" class="row">
            <div class="col-12">
              <h2 class="text-center">
                Invalid Token!
                <span class="text-light-blue d-block"></span>
              </h2>
            </div>
          </div>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "SignIn",
  mounted() {
    this.token = this.$route.params.token;
    this.checkToken();
  },
  data() {
    return {
      serverErrors: "",
      token: "",
      serverResponse: false,
      accountActivated: false
    };
  },
  methods: {
    loginRedirection() {
      this.$router.push({ name: "Login" });
    },
    checkToken() {
      axios
        .get("api/auth/signup/activate/" + this.token)
        .then(() => {
          this.serverResponse = true;
          this.accountActivated = true;
        })
        .catch(() => {
					this.serverResponse = true;
          this.accountActivated = false;
        });
    }
  }
};
</script>

<style>
.invalid-feedback {
  display: block;
}
.form-control {
  text-transform: none;
}
</style>